const MAX_TAB = 90;

export default MAX_TAB;
